import React from 'react';

const defaultRenderCell = (zoneKey, extraClass = '') => (
  <div className={`layout-cell${extraClass ? ` ${extraClass}` : ''}`} />
);

const PortletLayoutPreview = ({ layoutNum, renderCell }) => {
  const render = (zoneKey, extraClass = '') => {
    const renderer = renderCell || defaultRenderCell;
    return <React.Fragment key={zoneKey}>{renderer(zoneKey, extraClass)}</React.Fragment>;
  };

  return (
    <div className={`layout-grid-preview template-${layoutNum}`}>
      {layoutNum === 1 && (
        <>
          {render('0-0', 'cell-wide')}
          {render('1-0')}
          {render('1-1')}
        </>
      )}
      {layoutNum === 2 && (
        <>
          {render('0-0')}
          {render('0-1')}
          {render('1-0', 'cell-wide')}
        </>
      )}
      {layoutNum === 3 && (
        <>
          {render('0-0')}
          {render('0-1')}
          {render('1-0')}
          {render('1-1')}
        </>
      )}
      {layoutNum === 4 && (
        <>
          <div className="layout-row">
            {render('0-0')}
            {render('0-1')}
          </div>
          <div className="layout-row">
            {render('1-0')}
            {render('1-1')}
            {render('1-2')}
          </div>
        </>
      )}
      {layoutNum === 5 && (
        <>
          <div className="layout-row">
            {render('0-0')}
            {render('0-1')}
            {render('0-2')}
          </div>
          <div className="layout-row">
            {render('1-0')}
            {render('1-1')}
          </div>
        </>
      )}
      {layoutNum === 6 && (
        <>
          {render('0-0')}
          {render('0-1')}
          {render('0-2')}
          {render('1-0')}
          {render('1-1')}
          {render('1-2')}
        </>
      )}
    </div>
  );
};

export default PortletLayoutPreview;
